import { Component } from '@angular/core';

@Component({
  selector: 'app-akky-pro',
  templateUrl: './akky-pro.component.html',
  styleUrls: ['./akky-pro.component.css']
})
export class AkkyProComponent
{

}
